import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		redirect: '/login'
	},
	{
		path: '/login',
		name: "login",
		component: resolve => require(['../views/loginPage.vue'], resolve)
	},
	{
		path: '/agent',
		name: 'agent',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import('../components/common/agentComponent.vue'),
		children: [
			//代理商列表
			{
				path: '/agent/createAgent',
				name: 'createAgent',
				component: () => import('../views/agent/createAgent.vue')
			},
			{
				path: '/agent/agentList',
				name: 'agentList',
				component: () => import('../views/agent/agentList.vue')
			},
			{
				path: '/agent/agentDetails',
				name: 'agentDetails',
				component: () => import('../views/agent/agentDetails.vue')
			},{
				path: '/agent/businessExplain',
				name: 'businessExplain',
				component: () => import('../views/agent/businessExplain.vue')
			},
			{
				path: '/agent/businessList',
				name: 'businessList',
				component: () => import('../views/agent/businessList.vue')
			},
			{
				path: '/agent/businessBindList',
				name: 'businessBindList',
				component: () => import('../views/agent/businessBindList.vue')
			},
			
		]
	},{
		path: '/active',
		name: 'active',
		component: () => import('../components/common/agentComponent.vue'),
		children: [
			{
				path: '/active/agentActive',
				name: 'agentActive',
				component: () => import('../views/active/agentActive.vue')
			},
			{
				path: '/active/createAgentActive',
				name: 'createAgentActive',
				component: () => import('../views/active/createAgentActive.vue')
			},
			{
				path: '/active/agentOrderList',
				name: 'agentOrderList',
				component: () => import('../views/active/agentOrderList.vue')
			},
			{
				path: '/active/orderDetails',
				name: 'orderDetails',
				component: () => import('../views/active/orderDetails.vue')
			},
		]
	},{
		path: '/message',
		name: 'message',
		component: () => import('../components/common/agentComponent.vue'),
		children: [
			{
				path: '/message/agentMessage',
				name: 'agentMessage',
				component: () => import('../views/message/agentMessage.vue')
			}
		]
	},{
		path: '/count',
		name: 'count',
		component: () => import('../components/common/agentComponent.vue'),
		children: [
			{
				path: '/count/buttonList',
				name: 'buttonList',
				component: () => import('../views/count/buttonList.vue')
			},
			{
				path: '/count/ruleList',
				name: 'ruleList',
				component: () => import('../views/count/ruleList.vue')
			}
		]
	},{
		path: '/settle',
		name: 'settle',
		component: () => import('../components/common/agentComponent.vue'),
		children: [
			{
				path: '/settle/settlementList',
				name: 'settlementList',
				component: () => import('../views/settle/settlementList.vue')
			},{
				path: '/settle/testQr',
				name: 'testQr',
				component: () => import('../views/settle/testQr.vue')
			}
		]
	},
	{
		path: '/regimen_countryLearn',
		name: 'regimen_countryLearn',
		component: () => import('../components/common/agentComponent.vue'),
		children: [
			{
				path: '/regimen_countryLearn/channelAgentList',
				name: 'channelAgentList',
				component: () => import('../views/regimen_countryLearn/channelAgentList.vue')
			},
			{
				path: '/regimen_countryLearn/performanceList',
				name: 'performanceList',
				component: () => import('../views/regimen_countryLearn/performanceList.vue')
			},
			{
				path: '/regimen_countryLearn/incomeList',
				name: 'incomeList',
				component: () => import('../views/regimen_countryLearn/incomeList.vue')
			},
			{
				path: '/regimen_countryLearn/staff-product',
				name: 'staff-product',
				component: () => import('../views/regimen_countryLearn/staff-product.vue')
			},
			{
				path: '/regimen_countryLearn/produceList',
				name: 'produceList',
				component: () => import('../views/regimen_countryLearn/produceList.vue')
			},
			{
				path: '/regimen_countryLearn/categoryList',
				name: 'categoryList',
				component: () => import('../views/regimen_countryLearn/categoryList.vue')
			},
			{
				path: '/regimen_countryLearn/companyManage',
				name: 'companyManage',
				component: () => import('../views/regimen_countryLearn/companyManage.vue')
			},
		]
	},
	{
		path: '/litaOperate',
		name: 'litaOperate',
		component: () => import('../components/common/agentComponent.vue'),
		children: [
			{
				path: '/litaOperate/companyManage',
				name: 'companyManage',
				component: () => import('../views/litaOperate/companyManage.vue')
			},
			{
				path: '/litaOperate/moudleManage',
				name: 'moudleManage',
				component: () => import('../views/litaOperate/moudleManage.vue')
			},
			{
				path: '/litaOperate/moudleUrlManage',
				name: 'moudleUrlManage',
				component: () => import('../views/litaOperate/moudleUrlManage.vue')
			},
			{
				path: '/litaOperate/urlManage',
				name: 'urlManage',
				component: () => import('../views/litaOperate/urlManage.vue')
			},
			{
				path: '/litaOperate/testDeom',
				name: 'testDeom',
				component: () => import('../views/litaOperate/testDeom.vue')
			},
			{
				path: '/litaOperate/dataStatistic',
				name: 'dataStatistic',
				component: () => import('../views/litaOperate/dataStatistic.vue')
			},
			{
				path: '/litaOperate/everydayDataStatistic',
				name: 'everydayDataStatistic',
				component: () => import('../views/litaOperate/everydayDataStatistic.vue')
			},
			{
				path: '/notFound',
				name: 'notFound',
				component: () => import('../views/notFound.vue')
			}
		]
	},
	{
		path: '/qw',
		name: 'qw',
		component: () => import('../components/common/agentComponent.vue'),
		children: [
			{
				path: '/qw/moudleManage',
				name: 'moudleManage',
				component: () => import('../views/qw/moudleManage.vue')
			},
			{
				path: '/qw/dataStatistic',
				name: 'dataStatistic',
				component: () => import('../views/qw/dataStatistic.vue')
			},
			
		]
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

export default router